module.exports = __webpack_public_path__ + "static/media/streetQuestion.cb12b6c8.png";